

require.config({
	//Initialize the application with the main application file.
	"deps": [
		"almond",
		"index"
	],

	"waitSeconds": 30,
	
	"paths": {
		//Index paths
		"indexView":"app/views/indexView",
		"index": "app/index",

		// Core App Modules
		"constants": "app/oaConstants",
		"oaConfig": "app/oaConfig",
		"sessionInfo" : "app/sessionInfo",
		"utils" : "app/utils",
		"handlebarsHelpers":"app/handlebarsHelpers",
		"templates":"app/oaTemplates",
		"oaEvents": "app/oaEvents",

		// Core JS Libs
		"jquery": "lib/jquery-1.10.2",
		"underscore": "lib/underscore-1.9.1",
		"handlebars":"lib/handlebars.runtime.min-v4.7.3",
		"backbone": "lib/backbone-1.1.2",
		"marionette": "plugins/backbone/backbone.marionette-2.4.0-tsgcustomized",
		"moment":"lib/moment-with-locales.min-v2.24.0",
		"underscore-string": "plugins/underscore.string-3.0.3",
		"materialdesignweb":"lib/material-design-web/material-components-web-7.0.0.min",
		
		// Core JS Libs
		"l10n":"lib/l10n",

		"localizationService":"app/localizationService",
		"tsgUtils": "lib/tsgUtils/src/tsgUtils",
		"abstractDocumentModel": "lib/tsgUtils/src/abstractDocumentModel",
		"abstractTreeView": "lib/tsgUtils/src/abstractTreeView",
		
		
		// jQuery Plugins
		"jquery-cookie": "plugins/jquery/jquery.cookie-1.4.0",

		// Almond.js for requirejs
		"almond": "lib/almond"
		
	},
	"shim" : {
		"underscore" : {
			"exports": "_"
		},
		"backbone": {
			"deps": [
				"underscore",
				"jquery"
			],
			"exports" : "Backbone"
		},
		"marionette": {
			"deps": [
				"backbone"
			],
			"exports" : "Marionette"
		}
	}

});
define("config/config-index", function(){});

